import { connect } from "react-redux";
import {
    ModalInformationStyled,
    ModalWrapperStyled
} from "./styled/ModalsStyled.js";
import { Modal } from "react-bootstrap";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";
import Settings from "../Settings/Settings";
import { useCallback } from "react";
import { MODALS_NAME } from "./modalsConstants";
import { openModalAction } from "../../app/appActions";

function SettingsModal(props) {
    const {closeModal, openModal} = props;

    const {getLangPath} = useLangContext();

    const handleOpenResetPasswordModal = useCallback(() => openModal(MODALS_NAME.RESET_PASSWORD), [openModal]);

    return <ModalInformationStyled>
        <Modal.Header closeButton>
            {getLangPath('menu.settings')}
        </Modal.Header>
        <ModalWrapperStyled>
            <Settings onPasswordResetClick={handleOpenResetPasswordModal} onSuccessPasswordChangeCallback={closeModal}/>
        </ModalWrapperStyled>
    </ModalInformationStyled>
}

const mapDispatchToProps = (dispatch) => ({
    openModal: (payload) => dispatch(openModalAction(payload)),
});

export default connect(null, mapDispatchToProps)(SettingsModal);
